import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MemoryRouter } from 'react-router-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { Reducer } from './reducer';

let myStore = createStore(Reducer);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <MemoryRouter>
    <Provider store={myStore}>
    <App />
    </Provider>
    </MemoryRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
